import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private httpClient: HttpClient, private apiService: ApiService) { }

  public badges(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/badges`);
  }

  public assignments(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/assignments`);
  }

  public getPlatformFee(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/platform-fee`);
  }

  public getStats(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/stats`);
  }

  public assignment(assignmentId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/assignments/${assignmentId}`);
  }

  public tnc(organizationId: number | null): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${organizationId}/organization/tnc`);
  }

  public salaryRules(salaryRulesId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/salary-rules/${salaryRulesId}`);
  }

  public assignmentsPublic(organizationId?: number): Observable<any> {
    if (!organizationId) {
      organizationId = this.apiService.organizationId()
    }
    
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${organizationId}/assignments`);
  }

  public assignmentPublicBySlug(slug: string): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/assignments`, { params: new HttpParams({ fromObject: { slug: slug } }) });
  }

  public assignmentsPopular(organizationId?: number): Observable<any> {
    if (!organizationId) {
      organizationId = this.apiService.organizationId()
    }

    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${organizationId}/assignments/popular`);
  }

  public assignmentPublic(assignmentId: number, organizationId?: number): Observable<any> {
    if (!organizationId) {
      organizationId = this.apiService.organizationId()
    }
    
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${organizationId}/assignments/${assignmentId}`);
  }

  public areasPublic(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/areas`);
  }

  public citiesPublic(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/cities`);
  }

  public areaByCoordinates(lat: number, long: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/area-by-coordinates`, { params: new HttpParams({ fromObject: { lat: lat, long: long } }) });
  }

  public holidaysPublic(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/holidays`);  
  }

  public get(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/settings`);  
  }

  public customer(customerId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/settings/customers/${customerId}`);  
  }

  public customerSave(customerId: number, data: {}): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/settings/customers/${customerId ? customerId : ''}`, data);  
  }

  public customerDelete(customerId: number): Observable<any> {
    return this.httpClient.delete(`${this.apiService.apiUrl()}/api/customer/settings/customers/${customerId}`);  
  }

  public assignmentProducts(assignmentId: number, date: any, customer: any): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/products`, { params: new HttpParams({ fromObject: { assignment: assignmentId, date: date, customer: customer } }) });
  }

  public assignmentProductsPublic(assignmentId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/products`, { params: new HttpParams({ fromObject: { assignment: assignmentId } }) });
  }

  public products(customerId: number, date: string): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/products`, { params: new HttpParams({ fromObject: { customer: customerId, date: date } }) });
  }

  public productsByIds(products: any): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/products-by-ids`, { products: products });
  }

  public employeeProducts(employeeId: number): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/employees/${employeeId}/products`);
  }

  public relatedProducts(products: any, date: any, customer: any): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/products/related`, { products: products, date: date, customer: customer });
  }

  public relatedProductsPublic(products: any): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/products/related`, { products: products });
  }

  public save(data: {}): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/settings`, data);
  }

  public organization(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/organization`);
  }

  public organizationPublic(organizationId?: number): Observable<any> {
    if (!organizationId) {
      organizationId = this.apiService.organizationId()
    }
    
    return this.httpClient.get(`${environment.master_url}/api/customer/public/${organizationId}/organization`);
  }

  public organizations(): Observable<any> {
    return this.httpClient.get(`${environment.master_url}/api/customer/organizations`);
  }

  public requirements(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/requirements`);
  }

  public removeAccount(): Observable<any> {
    return this.httpClient.delete(`${this.apiService.apiUrl()}/api/customer/settings`);
  }

  public setDefaultCard(cardId: number): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/settings/set-default-card`, {
      card: cardId
    });
  }

  public setDefaultCustomer(customerId: number): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/settings/set-default-customer`, {
      customer: customerId
    });
  }

  public removeCard(cardId: number): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/settings/remove-card`, {
      card: cardId
    });
  }

  public discounts(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/settings/discounts`);
  }

  public referrals(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/settings/referrals`);
  }

  public productRequestCreate(request: string): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/product-requests`, { request: request });
  }

  public uploadPicture(formData: FormData): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/settings/picture`, formData);
  }
}
